import { useEffect, useMemo } from "react";
import { PAGE_NAMES } from "../const/analytics";
import triggerAnalyticsEvent from "../helpers/triggerAnalytics";
import useRewards from "./useRewards";
import sortEarnings from "../helpers/sortEarnings";
var useRewardsAnalytics = function (_a) {
    var _b, _c, _d;
    var allRewardsCertificate = _a.allRewardsCertificate, _e = _a.pageSubFunction, pageSubFunction = _e === void 0 ? "" : _e, _f = _a.clientName, clientName = _f === void 0 ? "" : _f;
    var _g = useRewards(), rewardsBalance = _g.rewardsBalance, cardType = _g.cardType, clientId = _g.clientId, rewardsExperience = _g.rewardsExperience, rewardDetails = _g.rewardDetails, isLoading = _g.isLoading;
    var earnings = (_c = (_b = rewardsExperience === null || rewardsExperience === void 0 ? void 0 : rewardsExperience[clientId]) === null || _b === void 0 ? void 0 : _b[cardType]) === null || _c === void 0 ? void 0 : _c.earnings;
    var sortedEarnings = useMemo(function () { return sortEarnings({ rewardsBalance: rewardsBalance, earningsIcons: earnings === null || earnings === void 0 ? void 0 : earnings.icons }); }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [rewardsBalance === null || rewardsBalance === void 0 ? void 0 : rewardsBalance.rewardDetails, earnings === null || earnings === void 0 ? void 0 : earnings.icons]);
    var isEmptyEarnings = useMemo(function () { return sortedEarnings === null || sortedEarnings === void 0 ? void 0 : sortedEarnings.every(function (earning) { return earning.value === "0"; }); }, [sortedEarnings]);
    useEffect(function () {
        var _a;
        if (!isLoading) {
            if ((allRewardsCertificate === null || allRewardsCertificate === void 0 ? void 0 : allRewardsCertificate.certificateBalanceSum) &&
                ((_a = rewardDetails === null || rewardDetails === void 0 ? void 0 : rewardDetails.currentptsbalance) === null || _a === void 0 ? void 0 : _a.value)) {
                triggerAnalyticsEvent({
                    clientName: clientName,
                    pageSubFunction: pageSubFunction,
                    pageName: Number(allRewardsCertificate.certificateBalanceSum) === 0 &&
                        Number(rewardDetails.currentptsbalance.value) === 0
                        ? PAGE_NAMES.EMPTY
                        : PAGE_NAMES.VIEW,
                });
            }
            else if (sortedEarnings === null || sortedEarnings === void 0 ? void 0 : sortedEarnings.length) {
                triggerAnalyticsEvent({
                    clientName: clientName,
                    pageSubFunction: pageSubFunction,
                    pageName: isEmptyEarnings ? PAGE_NAMES.EMPTY : PAGE_NAMES.VIEW,
                });
            }
            else {
                triggerAnalyticsEvent({
                    clientName: clientName,
                    pageSubFunction: pageSubFunction,
                    pageName: PAGE_NAMES.VIEW,
                });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        allRewardsCertificate === null || allRewardsCertificate === void 0 ? void 0 : allRewardsCertificate.certificateBalanceSum,
        clientName,
        isEmptyEarnings,
        (_d = rewardDetails === null || rewardDetails === void 0 ? void 0 : rewardDetails.currentptsbalance) === null || _d === void 0 ? void 0 : _d.value,
        sortedEarnings === null || sortedEarnings === void 0 ? void 0 : sortedEarnings.length,
        isLoading,
    ]);
};
export default useRewardsAnalytics;
